import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OeAppService } from './oe-app.service';
import { TokenService } from './token.service';
import { isHostListed, urlNeedsBearer } from './auth-interceptor.helper';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private tokenService: TokenService, private oeAppService: OeAppService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const requestConfig = this.addAuthorizationTokenWhenNeeded(req);
    return next.handle(requestConfig);
  }

  addAuthorizationTokenWhenNeeded(requestConfig: HttpRequest<any>) {
    try {
      const config = this.oeAppService.environmentUrls;
      const { url } = requestConfig;
      const needsAuthorization = isHostListed(url, config.authorizationList);
      const token = this.tokenService.token;
      if (token && needsAuthorization) {
        return requestConfig.clone({ headers: requestConfig.headers.set('Authorization', this.tokenService.token) });
      }

      const needsBearerAuthorization = urlNeedsBearer(url, config);
      if (token && needsBearerAuthorization) {
        return requestConfig.clone({
          headers: requestConfig.headers.set('Authorization', `Bearer ${this.tokenService.token}`),
        });
      }
    } catch (e) {
      // EMPTY
    }

    return requestConfig;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/auth-interceptor.ts